import React from 'react'
import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'
import slugify from 'slugify'

import { Header } from '../Component/Header'
import { InfosService } from '../Services/InfosService'

class Infos extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      termes: []
    }
  }

  componentDidMount () {
    InfosService.getFirstDepthThemes()
      .then(
        text => {
          const data = JSON.parse(text)
          this.setState({
            termes: data.message ? data.message : ''
          })
        },
        error => this.setState({ error, loading: false })
      )
  }

  render () {
    const {
      termes
    } = this.state
    return (
      <div className='InfosWrapper'>
        <Header title='Actualités' />
        <div className='mainContent paddingOnlyLeft'>
          <ul className='InfosListe'>
            {!isEmpty(termes) && termes.map((item, i) =>
              <li className='flex items-center justify-between' key={i}>
                <Link
                  className='w-full'
                  to={{
                    pathname: `/actus/${slugify(item.label, {
                      replacement: '-',
                      remove: null,
                      lower: true
                    })}`,
                    subpage: item.label
                  }}
                >
                  {item.label}
                </Link>
                <i className='icofont-simple-right icofont-md pr-8' />
              </li>
            )}
          </ul>
        </div>
      </div>
    )
  }
}

export { Infos }
